import React from "react";
import ToolDetail from "../../../components/dashboard/tools/ToolDetail";

const ToolViewPage = () => {
  return <ToolDetail />;
};

export { ToolViewPage as ToolView };
